export default __webpack_public_path__ + "static/media/IconDesc_C_Inv_Ramp_8x3_02.256.cae946e5.png";